export const API_URL = import.meta.env.VITE_API_URL || 'https://content-review-api.ryantoth2410.workers.dev';
export const API_BASE_URL = API_URL.replace('/api', '');

export interface FeedbackPin {
  id: string;
  x: number;
  y: number;
  comment: string;
  author?: string;
  timestamp: Date;
}

export interface AssetType {
  label: string;
  value: string;
  category: 'media' | 'content' | 'technical';
  exists?: boolean;
  suggested?: boolean;
}

export interface AssetTypeCategories {
  media: AssetType[];
  content: AssetType[];
  technical: AssetType[];
}